import React, { useState } from "react";
import "../css/SetNewPassword.css";
import { useNavigate } from "react-router-dom";
import dogCatImage from "../assets/view-cats-dogs-showing-friendship 1.png";

const SetNewPassword = () => {
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [passwordError, setPasswordError] = useState("");
  const [confirmPasswordError, setConfirmPasswordError] = useState("");
  const navigate = useNavigate();

  const handleSubmit = (e) => {
    e.preventDefault();

    let isValid = true;

    // Reset previous errors
    setPasswordError("");
    setConfirmPasswordError("");

    // Validate password
    if (!password) {
      setPasswordError("Please enter password");
      isValid = false;
    } else if (password.length < 6) {
      setPasswordError("Please enter minimum 6 characters");
      isValid = false;
    }

    // Validate confirm password
    if (!confirmPassword) {
      setConfirmPasswordError("Please enter confirm password");
      isValid = false;
    } else if (password && password !== confirmPassword) {
      setConfirmPasswordError("Passwords do not match");
      isValid = false;
    }

    if (isValid) {
      navigate("/success");
    }
  };

  return (
    <div className="snp-login-container">
      <div className="snp-login-left">
        <h2 className="snp-login-left-header">
          Reset Your Password – Reconnect With Your Pet’s World!
        </h2>
        <img className="snp-image" src={dogCatImage} alt="Dog and Cat" />
      </div>
      <div className="snp-login-right">
        <h2 className="snp-login-right-header">Set a new password</h2>
        <p className="snp-instruction">
          Create a new password. Ensure it differs from previous ones for
          security
        </p>
        <form className="snp-login-right-form" onSubmit={handleSubmit}>
          <div className="snp-input-cnt">
            <label className="snp-login-right-label">Password</label>
            <input
              className="snp-login-right-input"
              type="password"
              placeholder="Enter your new password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
            />
            {passwordError && <p className="snp-error">{passwordError}</p>}
          </div>
          <div className="snp-input-cnt">
            <label className="snp-login-right-label">Confirm Password</label>
            <input
              className="snp-login-right-input"
              type="password"
              placeholder="Re - enter password"
              value={confirmPassword}
              onChange={(e) => setConfirmPassword(e.target.value)}
            />
            {confirmPasswordError && (
              <p className="snp-error">{confirmPasswordError}</p>
            )}
          </div>

          <button type="submit" className="snp-update-btn">
            Update password
          </button>
        </form>
      </div>
    </div>
  );
};

export default SetNewPassword;